import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, ApiVisa, PagingResponseModel, ApiResponseModel, Pagination } from '../../shared';
import { MembershipPointsCurrentBalanceDto, MembershipPointsTxnContainerModel, MembershipPointsTxnLineContainerModel } from '../../../../../../models/aggregates/crm/membership-points-txn';
import { Core2Config } from '../../shared';
import { Observable } from 'rxjs';
import { MembershipPointsTxnQueryCriteriaClass, MembershipPointsTxnCriteriaModelQuery } from '../../../criteria/membership-points-txn-query-criteria.model';

@Injectable({
  providedIn: 'root'
})
export class MembershipPointsTxnService extends BaseApiTemplateService<MembershipPointsTxnContainerModel> {
  
  static readonly MEMBERSHIP_POINTS_TXN_PATH = 'membership-points-txn/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipPointsTxnService.MEMBERSHIP_POINTS_TXN_PATH + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipPointsTxnService.MEMBERSHIP_POINTS_TXN_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipPointsTxnService.MEMBERSHIP_POINTS_TXN_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipPointsTxnService.MEMBERSHIP_POINTS_TXN_PATH + BaseApiTemplateService.PUBLIC_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipPointsTxnService.MEMBERSHIP_POINTS_TXN_PATH + BaseApiTemplateService.LOGIN_ENTITY_EP;
  }

  postToLinesDirect(visa: ApiVisa, body: MembershipPointsTxnLineContainerModel) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/lines";
    }

    return this.httpClient.post<PagingResponseModel<MembershipPointsTxnLineContainerModel>>(this.apiUrl, body,
      this.getHttpHeader(visa));
  }
  
  postToTxnLinesDirect(visa: ApiVisa, body: MembershipPointsTxnLineContainerModel) {
    if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipPointsTxnService.MEMBERSHIP_POINTS_TXN_PATH + 'txn-line/' + BaseApiTemplateService.BACKOFFICE_EP;
    }

    return this.httpClient.post<PagingResponseModel<MembershipPointsTxnLineContainerModel>>(this.apiUrl, body,
      this.getHttpHeader(visa));
  }

  getByCriteriaLines(pagination: Pagination,
    visa: ApiVisa) {

    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/lines";
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MembershipPointsTxnLineContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getByCriteriaLinesLoginEntity(pagination: Pagination,
    visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_entity_url + "/lines";
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MembershipPointsTxnLineContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getByGuidLines(guid: string,
    visa: ApiVisa) {

    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/lines";
    }
    return this.httpClient.get<ApiResponseModel<MembershipPointsTxnLineContainerModel>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  getMembershipPointsTxnByCriteria(visa: ApiVisa, criteria?: MembershipPointsTxnQueryCriteriaClass):
    Observable<PagingResponseModel<MembershipPointsTxnContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildEntityCriteriaCriteria = new MembershipPointsTxnCriteriaModelQuery(criteria);
    return this.httpClient.get<PagingResponseModel<MembershipPointsTxnContainerModel>>(this.apiUrl + '/query?' +
      buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));
  }

  getBalanceByCardNumber(cardNo: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + `/balance/${cardNo}`;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }

  getBalanceByCardNumberLogin(cardNo: string, apiVisa: ApiVisa) {
    if (this.endpoint_path_login_entity_url && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path_login_entity_url
    }
    const url = this.apiUrl + `/balance/${cardNo}`;
    return this.httpClient.get<ApiResponseModel<MembershipPointsCurrentBalanceDto>>(
      url, 
      this.getHttpHeader(apiVisa)
    );
  }

  getBalanceCurrencyByCardNumberLogin(cardNo: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path_login_url
    }
    const url = this.apiUrl + `/balance-currency/${cardNo}`;
    return this.httpClient.get<ApiResponseModel<MembershipPointsCurrentBalanceDto>>(
      url, 
      this.getHttpHeader(apiVisa)
    );
  }


  getMembershipPointCurrentBalanceByPointCurrency(cardNo: string, pointCurrency: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + `/current-balance/${cardNo}/${pointCurrency}`;
    return this.httpClient.get<ApiResponseModel<string>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }

  getMembershipPointCurrentBalance(cardNo: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + `/current-balance/${cardNo}`;
    return this.httpClient.get<ApiResponseModel<MembershipPointsCurrentBalanceDto>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }

  getMembershipPointCurrentBalanceLoginEntity(cardNo: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path_login_entity_url;
    }
    const url = this.apiUrl + `/current-balance/${cardNo}`;
    return this.httpClient.get<ApiResponseModel<MembershipPointsCurrentBalanceDto>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }
}


